import { getDefaultPlayerFields as getDefaultPlayerFieldsDefault } from 'js/hooks/usePlayerFields/helpers';

export { parsePlayerFields } from 'js/hooks/usePlayerFields/helpers';

export const getDefaultPlayerFields = () => {
    const playerFields = getDefaultPlayerFieldsDefault();

    return playerFields.concat([62, 63, 99, 100, 101, 102]);
};
